// src/store/authSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

interface AuthState {
    token: string | null;
    postionForm: string;
    mobile: string;
    name: string | null | undefined;
    wallet: string | undefined;
    status: boolean;
    register: string | null;
    panel: number | null;
    postionLogin_numberor_very: 'number' | 'very' | null;
    MobileNot_cookie: null | number;
    accessRoute: number | null;
    tracking_code: null | string;
}

const initialState: AuthState = {
    token: Cookies.get('token') || null,
    postionForm: 'login',
    wallet: undefined,
    mobile: '',
    name: undefined,
    panel: null,
    tracking_code: null,
    status: false,
    register: null,
    postionLogin_numberor_very: 'number',
    MobileNot_cookie: null,
    accessRoute: null,
};

const expires = new Date(new Date().getTime() + 60 * 24 * 60 * 60 * 1000);

const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
            if (action.payload) {
                Cookies.set('token', action.payload, { expires: expires });
            }
        },
        logout: (state) => {
            state.token = null;
            state.mobile = '';
            state.panel = null;
            state.name = undefined;
            state.wallet = undefined;
            state.register = null;
            state.status = false;
            state.accessRoute = null;
            Cookies.remove('token');
        },
        setPostionForm: (state, action: PayloadAction<string>) => {
            state.postionForm = action.payload;
        },
        saveWallet: (state, action: PayloadAction<string>) => {
            state.wallet = action.payload;
        },
        saveMobile: (state, action: PayloadAction<string>) => {
            state.mobile = action.payload;
        },
        saveName: (state, action: PayloadAction<string | null>) => {
            state.name = action.payload;
        },
        setStatus: (state, action: PayloadAction<boolean>) => {
            state.status = action.payload;
        },
        saveRegister: (state, action: PayloadAction<string>) => {
            state.register = action.payload;
        },
        setTracking_code: (state, action: PayloadAction<null | string>) => {
            state.tracking_code = action.payload;
        },
        setPostion_number_very: (
            state,
            action: PayloadAction<'number' | 'very'>,
        ) => {
            state.postionLogin_numberor_very = action.payload;
        },
        setMobileNot_cookie: (state, action: PayloadAction<number>) => {
            state.MobileNot_cookie = action.payload;
        },
        setAccessRoute: (state, action) => {
            state.accessRoute = action.payload;
        },
        setPanel: (state, action) => {
            state.panel = action.payload;
        },
    },
});

export const {
    setToken,
    logout,
    setPostionForm,
    saveMobile,
    saveName,
    saveWallet,
    setStatus,
    saveRegister,
    setPostion_number_very,
    setTracking_code,
    setMobileNot_cookie,
    setPanel,
    setAccessRoute,
} = AuthSlice.actions;
export default AuthSlice.reducer;
